import { Modal } from "@mui/material";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import CustomForm from "./CustomForm";

export default function MailchimpFormContainer({ openForm, setOpenForm, setError, setSuccess }) {
    
    const postUrl = `https://kwil.us12.list-manage.com/subscribe/post?u=${process.env.REACT_APP_MAILCHIMP_U}&id=${process.env.REACT_APP_MAILCHIMP_ID}`
    
    return(
        <Modal
            open={openForm}
            onClose={() => setOpenForm(false)}
            sx={{ display: "flex" }}
        >
            <div style={{ margin: "auto"}}>
                <MailchimpSubscribe
                    url={postUrl}
                    render={({ subscribe, status, message }) => (
                        <CustomForm
                            status={status}
                            message={message}
                            onValidated={formData => subscribe(formData)}
                            setError={setError}
                            setSuccess={setSuccess}
                            setOpenForm={setOpenForm}
                        />
                    )}
                />
            </div>
                
        </Modal>
    )
}